import axios from 'axios';

export const instance = axios.create({
  baseURL: 'api'
});

export let configId: string;

export function setConfigId(id: string) {
  configId = id;
}

export enum CaseSource {
  AGS = 'AGS',
  ByggR = 'ByggR',
  Ecos = 'Ecos',
  iipax = 'iipax'
}

export type CaseTab = 'Preview' | 'Occurrences' | 'Persons' | 'Archive';

export enum ArendeStatus {
  Avslutat = 'Avslutat',
  Pågående = 'Pågående',
  Gallrat = 'Gallrat',
  Makulerat = 'Makulerat'
}

type Type = 'Adress' | 'Fastighet' | 'Ärende';

export interface SearchResult {
  value?: string;
  addressName?: string;
  estateId?: string;
  displayName: string;
  estateName: string;
  source?: CaseSource | 'FB';
  type?: Type;
  caseSourceId?: string;
}

export enum Visibility {
  Hide,
  Restrict,
  Show
}

export interface CaseSourceOption {
  value: string;
  label: string;
  caseSource: CaseSource;
}

export interface SelectOption {
  value: string;
  label: string;
  active?: boolean;
}

export async function search(query: string, source?: CaseSource | 'FB') {
  let url = `search?query=${query}`;
  if (configId) {
    url = `${url}&configId=${configId}`;
  }
  if (source) {
    url = `${url}&source=${source}`;
  }

  const { data } = await instance.get<SearchResult[]>(url);
  return data;
}
